import withSort from 'elements/HOC/withSort'
import CountrySelect from 'elements/Select/Country'
import CustomSelect from 'elements/Select/CustomSelect'
import withData from 'elements/Select/withData'
import AccountsTreeSelect from 'elements/TreeSelect/AccountsTreeSelect'
import { get } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout } from 'modules/FormItems'
import { strVal } from 'modules/Utils'
import React, { Component } from 'react'
import { Card, Col, Form, Input, Select } from 'antd'
import { compose } from 'recompose'

const KindSelect = compose(
  withData({
    data: [
      { key: 'organisation', value: 'Organisation' },
      { key: 'individual', value: 'Individual' },
    ],
  }),
  withSort
)(CustomSelect)

function ContactDetails(props) {
  const { member, form } = props
  const { getFieldDecorator, getFieldValue } = form

  const kind = getFieldValue('kind')
  const isOrg = kind === 'organisation'

  return (
    <div className="flex mx-auto max-w-3xl mt-10">
      <Form>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label={'Full Name'}>
            {getFieldDecorator('fn', {
              initialValue: strVal(member, 'fn'),
            })(<Input placeholder="Full Name" />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Trade Name'}>
            {getFieldDecorator('tradeName', {
              initialValue: strVal(member, 'tradeName'),
            })(<Input placeholder="Trade Name" />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Kind'}>
            {getFieldDecorator('kind', {
              initialValue: strVal(member, 'kind'),
            })(<KindSelect placeholder="kind" />)}
          </Form.Item>
        </Col>

        {!isOrg &&( <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Position'}>
              {getFieldDecorator('position', {
                initialValue: strVal(member, 'position'),
              })(<Input placeholder="Position" />)}
            </Form.Item>
          </Col>
        )}

        {isOrg &&( <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Registration No'}>
              {getFieldDecorator('companyNo', {
                initialValue: strVal(member, 'companyNo'),
              })(<Input placeholder="Registration No" />)}
            </Form.Item>
          </Col>
        )}

        {isOrg &&( <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Tax Registration No'}>
              {getFieldDecorator('taxRegistration', {
                initialValue: strVal(member, 'position'),
              })(<Input placeholder="Tax Registration No" />)}
            </Form.Item>
          </Col>
        )}


        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Location'}>
            {getFieldDecorator('location', {
              initialValue: strVal(member, 'location'),
            })(<CountrySelect />)}
          </Form.Item>
        </Col>
      </Form>
    </div>
  )
}

export default Form.create()(ContactDetails)
